/*
 * All You Can Play - testi del pulsante e della finestra dell'app Back in Stock (CWILL) nella lingua della pagina.
 * L'app ha i testi solo in inglese e sulle pagine in italiano li chiede al suo server, che rimanda quelli inglesi.
 * Questo file è "defer" e nella pagina sta prima dello script dell'app: gira dopo che l'app ha scritto le sue
 * impostazioni (bis_product_button_settings, bis_popup_settings) e prima che le usi. Mette i nostri testi,
 * scritti nel blocco "Liquid personalizzato" della pagina prodotto (window.aycpRestockText), e la lingua
 * della pagina, così l'app usa questi e non chiede i suoi al server.
 * Se un aggiornamento dell'app cambia questi nomi, tornano semplicemente i suoi testi inglesi.
 */
(function () {
  var texts = window.aycpRestockText;
  var lang = window.Shopify && window.Shopify.locale;
  if (!texts || !lang) return;

  var button = window.bis_product_button_settings;
  if (button && typeof button === 'object') {
    button.lang = lang;
    button.inline_btn_text = texts.button;
  }

  var popup = window.bis_popup_settings;
  if (popup && typeof popup === 'object') {
    popup.lang = lang;
    Object.keys(texts.popup).forEach(function (key) {
      popup[key] = texts.popup[key];
    });
  }
})();
